/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-11T17:16:49.215
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentLegalEntityEditInit,
	getRentLegalEntityView
} from '@api/rentmanage/RentLegalEntity';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentLegalEntityEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLegalEntityEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLegalEntityView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLegalEntityView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
